import React, { useEffect, useState } from 'react';
import { Modal, Col, Row, message, Spin} from 'antd';
import {getFileContent } from '../../services/ide-apis';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { solarizedlight } from 'react-syntax-highlighter/dist/esm/styles/prism'; 

const SourceCodeModal = ({ isOpen, handleCancel, currentRecord }) => {

    const [inputCode, setInputCode] = useState("");
    const [loader, setLoader] = useState(true);
    const language = currentRecord.projectType === "html_css" ? "html" : currentRecord.projectType;

    useEffect(() => {
        const fetchFileContent = async () => {
            setLoader(true);

            let files = currentRecord.fileMetaList.filter(file => file.isFile);
            let fileContents = [];

            for (let file of files) {
                try {
                    const response = await getFileContent(currentRecord.projectId, file.id);
                    const res = response.data;
                    if (res.statusCode === 200) {
                        fileContents.push({ fileName: file.fileName, fileContent: res.fileContent, path:file.path });
                    } else {
                        message.error(res.message);
                    }
                } catch (error) {
                    message.error("Error fetching file content");
                }
            }
            setInputCode(fileContents);
            setLoader(false);
        };

        if (currentRecord) {
            fetchFileContent();
        }
    }, [currentRecord]);

  return (
      
    <Modal
        width={900}
        open={isOpen}
        onCancel={handleCancel}
        footer={null}
        style={{ marginTop: '-30px' }}
        >
        {loader ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <Spin />
            </div>
        ) : (
            <>
                <Row>
                    <Col xs={24}>
                        <span className='poppins-bold d-block' style={{fontSize:'24px'}}>View Code</span>
                        <span className='poppins-bold'>{currentRecord.title} - </span><span className='poppins-regular'>{currentRecord.name}</span>
                    </Col>
                </Row>
                
                <Row className='mt-2'>
                    <Col xs={24}>
                        {inputCode.map((file, index) => (
                            <div className='border mt-1' style={{ borderRadius: '5px' }}>
                                <h5 className='p-2' style={{ backgroundColor: '#f5f5f5', borderRadius: '5px' }}>
                                    {file.path && ` ${file.path}/`}{file.fileName}
                                </h5>
                                <div style={{maxHeight:'300px', overflowY:'auto'}}>
                                    <SyntaxHighlighter language={language}
                                        style={solarizedlight}
                                        customStyle={{ backgroundColor: '#fffff' }}
                                        showLineNumbers
                                    >
                                        {file.fileContent}
                                    </SyntaxHighlighter>
                                </div>
                            </div>
                        ))}
                    </Col>
                </Row>
            </>
        )}
    </Modal>
  );
};

export default SourceCodeModal;
